/**
 * Accessible Disclosure component that controls visibility of a section of
 * content. It follows the WAI-ARIA Disclosure Pattern.
 *
 * @see https://reakit.io/docs/disclosure/
 *
 * The plan is to build own API that accounts for future breaking changes
 * in Reakit (https://github.com/WordPress/gutenberg/pull/28085).
 */
/* eslint-disable-next-line no-restricted-imports */
export { DisclosureContent } from 'reakit';
